import { render, staticRenderFns } from "./ItemAdminGeneralProduct.vue?vue&type=template&id=7ece391c&"
import script from "./ItemAdminGeneralProduct.vue?vue&type=script&lang=js&"
export * from "./ItemAdminGeneralProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports